// Screen-wide "looking into a video game" effect: a stack of translucent CSS
// layers (pixel grille + scanlines + vignette + a sweeping band). It's fixed,
// pointer-events-none, and offset from the left by the sidebar width so the
// nav icons stay crisp and clickable. All styling lives in index.css.
export default function CrtOverlay() {
    return (
        <div className="crt-overlay" aria-hidden="true">
            <div className="crt-sweep" />
        </div>
    )
}
